/**
 * Errores de las rutas de Consulta CM (sesiones, perfiles, responsables).
 *
 * La API responde `{ statusCode, codigo, message }`; `ApiClient` copia
 * `codigo` al `Error` que lanza. Aquí se traducen los códigos que una persona
 * de TI necesita entender sin abrir la consola.
 */

const MENSAJES: Record<string, string> = {
  CONFIRMAR_CUENTA_COMPARTIDA:
    'Es una cuenta compartida: esto saca a TODOS los equipos de la tienda. Marque la confirmación para seguir.',
  BAJA_PROPIA: 'No puede dar de baja su propia cuenta.',
  VIGENCIA_ANTERIOR:
    'La fecha es anterior a la asignación vigente. La historia no se reescribe: elija una fecha igual o posterior.',
  ASIGNACION_SIMULTANEA: 'Otra persona reasignó esta tienda al mismo tiempo. Recargue y vuelva a intentar.',
  FECHA_INVALIDA: 'La fecha no es válida (AAAA-MM-DD).',
  FECHA_FUERA_DE_RANGO: 'La fecha debe estar entre hoy − 7 días y hoy + 90 días.',
  NOMBRE_LARGO: 'El nombre no puede pasar de 80 caracteres.',
  MOTIVO_LARGO: 'El motivo no puede pasar de 200 caracteres.',
  CLAVE_INVALIDA: 'La clave sólo admite minúsculas, números, «-» y «_» (de 2 a 32).',
  CLAVE_DUPLICADA: 'Ya existe un perfil con esa clave.',
  NOMBRE_INVALIDO: 'El nombre del perfil no es válido.',
  MODULO_DESCONOCIDO: 'Uno de los módulos no existe en esta versión de la API.',
  PERFIL_NO_EXISTE: 'El perfil ya no existe. Recargue la lista.',
  PERFIL_CON_USUARIOS: 'El perfil tiene cuentas asignadas: quíteselo a esas cuentas antes de borrarlo, o desactívelo.',
  PERFIL_DE_FABRICA: 'Es un perfil de fábrica: se edita o se desactiva, pero no se borra.',
  PERFIL_INACTIVO: 'El perfil está desactivado: actívelo antes de asignarlo.',
  ROL_SIN_PERFIL:
    'Esta cuenta no lleva perfil (cuentas de tienda y bodega, vendedor y consulta se quedan en Venta Asistida).',
  ALCANCE_INVALIDO: 'Uno de los alcances no es válido.',
  NOMBRE_DESCONOCIDO: 'Ese supervisor o regional no está en el catálogo de responsables.',
  TIENDA_DESCONOCIDA: 'Esa tienda no está en el catálogo.',
  PERFILES_SIN_INSTALAR: 'La API de este entorno todavía no tiene la migración de perfiles.',
  MODULO_NO_PERMITIDO: 'Su perfil no incluye este módulo.',
  SESION_CERRADA: 'Sus sesiones se cerraron. Vuelva a iniciar sesión.',
  SESION_VENCIDA_ABSOLUTA: 'Por seguridad, la sesión pide volver a entrar cada 30 días.',
  REFRESH_REVOCADO: 'La sesión de este equipo se cerró. Vuelva a iniciar sesión.',
};

type ConCodigo = { codigo?: unknown; code?: unknown; statusCode?: unknown; message?: unknown };

export function codigoDe(e: unknown): string | null {
  if (!e || typeof e !== 'object') return null;
  const x = e as ConCodigo;
  if (typeof x.codigo === 'string' && x.codigo) return x.codigo;
  if (typeof x.code === 'string' && x.code) return x.code;
  return null;
}

export function statusDe(e: unknown): number | null {
  if (!e || typeof e !== 'object') return null;
  const s = (e as ConCodigo).statusCode;
  return typeof s === 'number' ? s : null;
}

export function mensajeDeError(e: unknown): string {
  const c = codigoDe(e);
  if (c && MENSAJES[c]) return MENSAJES[c];
  if (typeof e === 'string') return e;
  if (e && typeof e === 'object' && typeof (e as ConCodigo).message === 'string') {
    return (e as ConCodigo).message as string;
  }
  return 'No se pudo completar la operación.';
}

/**
 * La API de este entorno no ofrece la pantalla: la ruta no existe (404 sin
 * código: API anterior a Consulta CM) o le falta la migración. Así una pantalla
 * nueva sabe que tiene que decir «no disponible» en vez de «error», sin
 * depender de una constante compilada (lección del 31-ago).
 */
export function noDisponible(e: unknown): boolean {
  const s = statusDe(e);
  const c = codigoDe(e);
  if (s === 404 && !c) return true;
  return c === 'PERFILES_SIN_INSTALAR';
}
